<div style="margin-top: 90px;"></div>
<section id="about" data-scroll-index="0" class="white-bg padding-top-bottom" style="padding: 30px 0;">

  <div class="container features">
    <h2 class="section-title">ALPATA GRUBU</h2>
    <div class="row">

      <div class="col-sm-4 scrollimation fade-up in " style="width:100%; text-align:center;">

        <div class="media">
          <div class="media-body">
            <p>1959 yılında kurulan Alpata Grubu gıda mamülleri ve tütün ürünlerinin pazarlama ve dağıtımı, otomotiv,
              bilişim, sigortacılık, havacılık ve savunma sanayi sektörlerinde faaliyet gösteren altı şirketle 2000’e
              yakın kişiye doğrudan
              istihdam sağlamaktadır. Alpata Grubu, Sikorsky Aircraft (Lockheed Martin Company) ile ortaklık, Stellantis
              ve Philip Morris Pazarlama ve Satış A.Ş. gibi uluslararası devlerle partnerlik yapmaktadır.
            </p>
          </div>
        </div>

      </div>

    </div>

  </div>

</section>
<section id="portfolio" class="gray-bg padding-top-bottom portfolio">

  <div class="container">
    <h2 class="section-title">ALPATA GRUBU ŞİRKETLERİ</h2>



    <br />
    <!--==== Portfolio Filters ====-->

    <div class="projects-container scrollimation">

      <div class="row">

        <article class="col-md-4 col-sm-6 project-item web-design apps psd">

          <div class="project-thumb in " data-id="246a96e9-6da5-4eba-8da2-b84c2416892a">
            <a href="#alpata" class="main-link" (click)="GetCompanyCities(1)">
              <img class="img-responsive img-center"
                src="assets/images/company/246a96e9-6da5-4eba-8da2-b84c2416892a.tr.png" alt="" />
              <h2 class="project-title">NECDET ALPATA PAZARLAMA LOJİSTİK VE TURİZM SANAYİ VE TİCARET A.Ş.</h2>
              <span class="overlay-mask"></span>
            </a>
            <a class="link centered" (click)="GetCompanyCities(1)"><i class="fa fa-eye fa-fw"></i></a>
          </div>




        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">

          <div class="project-thumb in" data-id="3ad20862-0226-4548-ac82-e6487120c922">
            <a href="#otomotiv" class="main-link" (click)="GetCompanyCities(2)">
              <img class="img-responsive img-center"
                src="assets/images/company/3ad20862-0226-4548-ac82-e6487120c922.tr.png" alt="" />
              <h2 class="project-title">NECDET ALPATA A.Ş. OTOMOTİV ŞUBESİ</h2>
              <span class="overlay-mask"></span>
            </a>

            <a class="link centered" (click)="GetCompanyCities(2)"><i class="fa fa-eye fa-fw"></i></a>
          </div>

        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">

          <div class="project-thumb in " data-id="2073de91-8cbe-4d99-adea-6305b30c2184">
            <a href="#sigorta" class="main-link" (click)="GetCompanyCities(3)">
              <img class="img-responsive img-center"
                src="assets/images/company/2073de91-8cbe-4d99-adea-6305b30c2184.tr.png" alt="" />
              <h2 class="project-title">ALPATA SİGORTA ARACILIK HİZMETLERİ LTD. ŞTİ.</h2>
              <span class="overlay-mask"></span>
            </a>

            <a class="link centered" (click)="GetCompanyCities(3)"><i class="fa fa-eye fa-fw"></i></a>
          </div>

        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">

          <div class="project-thumb in " data-id="cbb2a481-ddfc-4850-88ff-95b98b4efeef">
            <a href="#havacilik" class="main-link" (click)="GetCompanyCities(4)">
              <img class="img-responsive img-center"
                src="assets/images/company/cbb2a481-ddfc-4850-88ff-95b98b4efeef.tr.png" alt="" />
              <h2 class="project-title">ALP HAVACILIK SANAYİ VE TİCARET A.Ş.</h2>
              <span class="overlay-mask"></span>
            </a>

            <a class="link centered" (click)="GetCompanyCities(4)"><i class="fa fa-eye fa-fw"></i></a>
          </div>

        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">

          <div class="project-thumb in" data-id="b15c2ea5-5819-45f9-a196-4fbca8860f6c">
            <a href="#teknoloji" class="main-link" (click)="GetCompanyCities(5)">
              <img class="img-responsive img-center" src="assets/images/company/necdet-alpata-as-teknoloji-tr.png"
                alt="" />
              <h2 class="project-title">NECDET ALPATA A.Ş. TEKNOLOJİ ŞUBESİ</h2>
              <span class="overlay-mask"></span>
            </a>

            <a class="link centered" (click)="GetCompanyCities(5)"><i class="fa fa-eye fa-fw"></i></a>
          </div>


        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">

          <div class="project-thumb in  " data-id="9fd40c5f-aa8d-4da2-8cec-85374ab956e2">
            <a href="#alpteknik" class="main-link" (click)="GetCompanyCities(6)">
              <img class="img-responsive img-center"
                src="assets/images/company/9fd40c5f-aa8d-4da2-8cec-85374ab956e2.tr.png" alt="" />
              <h2 class="project-title">ALPTEKNİK HAVACILIK SANAYİ VE TİCARET A.Ş.</h2>
              <span class="overlay-mask"></span>
            </a>

            <a class="link centered" (click)="GetCompanyCities(6)"><i class="fa fa-eye fa-fw"></i></a>
          </div>
        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">

          <div class="project-thumb in  " data-id="b15c2ea5-5819-45f9-a196-4fbca8860f5c">
            <a href="#alpatasrl" class="main-link" (click)="GetCompanyCities(7)">
              <img class="img-responsive img-center"
                src="assets/images/company/b15c2ea5-5819-45f9-a196-4fbca8860f5c.tr.png" alt="" />
              <h2 class="project-title">ALPATA S.R.L</h2>
              <span class="overlay-mask"></span>
            </a>

            <a class="link centered" (click)="GetCompanyCities(7)"><i class="fa fa-eye fa-fw"></i></a>
          </div>
        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">

          <div class="project-thumb in  " data-id="b15c2ea5-5819-45f9-a196-4fbca8860f5c">
            <a href="#alpatahavacilik" class="main-link" (click)="GetCompanyCities(8)">
              <img class="img-responsive img-center"
                src="assets/images/company/2073de91-8cbe-4d99-adea-6305b30c2185.tr.png" alt="" />
              <h2 class="project-title">ALPATA HAVACILIK</h2>
              <span class="overlay-mask"></span>
            </a>

            <a class="link centered" (click)="GetCompanyCities(8)"><i class="fa fa-eye fa-fw"></i></a>
          </div>
        </article>
      </div>

    </div>
  </div>

  <div *ngIf="gosterilenIsleme == 1" id="alpata">
    <div id="preview-scroll"></div>
    <div class="project-preview">

      <div class="container">

        <div class="preview-header text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(1)">×</a>
          <h1 class="preview-title">NECDET ALPATA PAZARLAMA LOJİSTİK VE TURİZM SANAYİ VE TİCARET A.Ş.</h1>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <img class="img-responsive" style=" margin-bottom:30px;" src="assets/images/company/alpata.png">
          </div>
        </div>

        <div class="imac-frame hidden">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>

        </div>
      </div>

      <div
        style="width: 100%; position: relative; background-size: cover; background-position: center center; color: black; background-image: url(assets/images/company/246a96e9-6da5-4eba-8da2-b84c2416892a_BG.png);"
        id="bgCompany">
        <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay">
        </div>
        <div class="container">

          <div class="row">
            <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">

              <p>Türkiye’nin önde gelen gıda, muhtelif ihtiyaç maddeleri, tütün mamülleri ve içecek dağıtım, pazarlama
                ve lojistik şirketlerinden olan Necdet Alpata A.Ş., faaliyetlerine 1959 yılında Kızılay Maden Suyu
                ürünlerinin Eskişehir’deki
                satış ve dağıtımı ile başlamıştır. Dağıtım ve pazarlaması yapılan ürün ailesine, zaman içerisinde
                Philip Morris Pazarlama ve Satış A.Ş., Erikli, Nestle Waters, Uludağ, Dimes, Doğuş,
                Haribo, Tat
                Bakliyat, Sleepy, Düzey, Pure Baby, Redbull gibi markaların ürünleri de eklenmiştir.</p>

              <p>2005 yılından itibaren Kütahya Merkez ve İlçelerinde, 2006 yılından itibaren Uşak Merkez ve
                İlçelerinde, 2008 yılından itibaren Muğla İlinin Bodrum ve Milas İlçelerinde ve 2013 yılından itibaren
                Bilecik ilinde ve 2018 yılından
                itibaren de Bursa’da satış ve dağıtım faaliyetlerinde bulunulmaktadır.</p>
              <p>Yakın zamanda Özgün Saha Satış Otomasyon ve video konferans & video konferans destekli satış otomasyonu
                çözümleri geliştirmiştir.</p>
              <p>Necdet Alpata A.Ş.‘nin faaliyet gösterdiği illerde toplam alanı yaklaşık 25.000 m² ve toplam kapalı
                depolama alanı 15.000 m² olan toplam 6 ana lojistik merkezi ve ayrıca tali depoları bulunmaktadır.
                Şirket merkezi ve şubelerinde
                yaklaşık 300 kişi çalışmaktadır.</p>

              <p></p>


              <div class="col-md-12 text-center"><a
                  href="https://e-sirket.mkk.com.tr/esir/Dashboard.jsp#/sirketbilgileri/12981" target="_blank"
                  style="color:blue;">Bilgi Toplumu Hizmetleri sayfamıza buradan
                  ulaşabilirsiniz.</a></div>
              <p>&nbsp;</p>


              <div class="bs-example bs-example-tabs" style="padding-top:15px;" id="filter-works">
                <ul id="myTab_6" role="tablist">
                  <li><a href="https://goo.gl/maps/NAhuCmpYDT2677p27" target="_blank"><i class="fa fa-map-marker"
                        style="margin-right:10px;"></i>Eskişehir (Merkez)</a></li>
                  <li><a href="https://goo.gl/maps/RcsHXyWfv71bAHhFA" target="_blank"><i class="fa fa-map-marker"
                        style="margin-right:10px;"></i>Bursa</a></li>

                  <li><a href="https://goo.gl/maps/FVLtbYQZZszJgMfz6" target="_blank"><i class="fa fa-map-marker"
                        style="margin-right:10px;"></i>Bilecik</a></li>
                  <li><a href="https://www.google.com/maps?q=37.05673599243164,27.3511962890625&z=17&hl=tr"
                      target="_blank"><i class="fa fa-map-marker" style="margin-right:10px;"></i>Bodrum</a></li>
                  <li><a href="https://www.google.com/maps?q=39.43760299682617,29.95660400390625&z=17&hl=tr"
                      target="_blank"><i class="fa fa-map-marker" style="margin-right:10px;"></i>Kütahya</a></li>
                  <li><a href="https://goo.gl/maps/YW7YKquK7T5MPrMWA" target="_blank"><i class="fa fa-map-marker"
                        style="margin-right:10px;"></i>Uşak</a></li>
                  <div id="myTabContent_6" class="tab-content"> </div>
                </ul>


              </div>
              <div class="clearfix"></div>

              <div class="row text-center">

                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Dimes.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Do%c4%9fu%c5%9f.png">
                </p>
                <!-- <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Ender.png">
                </p> -->
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Erikli.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Nestle.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Haribo.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/duzey.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/K%c4%b1z%c4%b1lay.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/purebaby.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Sleepy.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/tat.png">
                </p>
                <!-- <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Mixmey.png">
                </p> -->

                <!-- <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Original%20Gourmet.png">
                </p> -->
                <!-- <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/PM.png">
                </p> -->
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Red%20Bull.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Uluda%c4%9f.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/philipmorristext.png">
                </p>

              </div>

              <div class="clearfix"></div>

              <div class="company-social" style="margin-top:25px;">
                <a href="https://www.facebook.com/AlpataAS/" target=" _blank" class="alp-social"><i
                    class="fa fa-facebook"></i></a>
                <a href="https://twitter.com/alpata_as" target="_blank" class="alp-social">
                  <svg viewBox="0 0 24 24" aria-label="X" role="img" style="
                    fill: #0F1D41; width: 32px; margin-bottom: -5px;">
                    <g>
                      <path
                        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z">
                      </path>
                    </g>
                  </svg>
                </a>
                <a href="https://www.instagram.com/alpataas/" target="_blank" class="alp-social"><i
                    class="fa fa-instagram"></i></a>
              </div>

              <div class="clearfix"></div>

            </div>
          </div>
        </div>


      </div>
      <div class="container">
        <div class="preview-footer text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(1)">×</a>
        </div>
      </div>
      <!--End container -->

    </div>
  </div>

  <div *ngIf="gosterilenIsleme == 2" id="otomotiv">
    <div class="project-preview">

      <div class="container">

        <div class="preview-header text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(2)">×</a>
          <h1 class="preview-title">NECDET ALPATA A.Ş. OTOMOTİV ŞUBESİ</h1>
          <p class="preview-subtitle"></p>

        </div>

        <div class="imac-frame hidden">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>

        </div>
      </div>

      <div
        style="width: 100%; position: relative; background-size: cover; background-position: center center; color: black; background-image: url(assets/images/company/3ad20862-0226-4548-ac82-e6487120c922_BG.png);"
        id="bgCompany">
        <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay">
        </div>
        <div class="container">

          <div class="row">
            <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
              <p>
              </p>
              <p>Necdet Alpata A.Ş. Otomotiv Şubesi, 1990 yılında General Motors'a ait Opel ve Chevrolet'in kendi
                bölgesinde yetkili satıcısı ve satış sonrası merkezi olarak Alpata Grubuna katılmıştır.</p>

              <p>Necdet Alpata A.Ş. Otomotiv Şubesi, hizmet kalitesi ve Master Tech ünvanlı teknisyenleri ile 2004
                yılından bu yana Altın Opel Servisi ünvanını da taşımaktadır.</p>

              <p>2019 yılında yenilediği altyapısı ile, önde gelen küresel otomobil üreticisi ve yenilikçi mobilite
                çözümleri sağlayıcısı olan Stellantis markaları olan Peugeot ve Citroen’in, satış ve satış sonrası
                hizmetlerini de üstlenmiştir.
              </p>
              <p>Bunun yanı sıra Spoticar markası altında ikinci el araç satışları da yapılmaktadır.</p>
              <p>Eskişehir’in yanı sıra Kütahya ve Bilecik gibi illerdeki müşterilerine satış ve satış sonrası
                hizmetleri sağlayan Necdet Alpata A.Ş. Otomotiv Şubesi, 17.000 m² alana yayılan tesisleri, showroom ve
                servis ünitesi, parkları,
                cafeleri ve yeşil alanlarıyla, on binlerce müşterisine kaliteli hizmet sunmaktadır.</p>
              <p></p>




              <div class="bs-example bs-example-tabs" style="padding-top:15px;" id="filter-works">
                <ul id="myTab_10" role="tablist">
                  <div id="myTabContent_10" class="tab-content"> </div>
                </ul>


              </div>
              <div class="clearfix"></div>

              <div class="row text-center">


              </div>

              <div class="clearfix"></div>

              <img class="img-responsive" style="border-radius: 35px;margin-bottom:30px;"
                src="assets/images/company/alpataotomotiv.png">
              <div class="clearfix"></div>
              <div class="col-md-3">
                <h2 class="text-center"><strong>PEUGEOT</strong></h2>
                <div class="company-social" style="margin-top:25px;">
                  <a href="https://www.facebook.com/PeugeotAlpataOto/" target="_blank" class="alp-social"><i
                      class="fa fa-facebook"></i></a>
                  <a href="https://www.instagram.com/peugeotalpata/" target="_blank" class="alp-social"><i
                      class="fa fa-instagram"></i></a>
                </div>
                <div class="clearfix"></div>
                <div style="margin-top: 25px;">
                  <p class="text-center"><a class="btn btn-alpata" href="https://bayi.peugeot.com.tr/alpata"
                      target="_blank">WEB SİTESİ</a></p>
                </div>
              </div>
              <div class="col-md-3">
                <h2 class="text-center"><strong>CITROEN</strong></h2>
                <div class="company-social" style="margin-top:25px;">
                  <a href="https://www.facebook.com/citroenAlpata/" target="_blank" class="alp-social"><i
                      class="fa fa-facebook"></i></a>
                  <a href="https://www.instagram.com/citroenalpataoto/" target="_blank" class="alp-social"><i
                      class="fa fa-instagram"></i></a>
                </div>
                <div class="clearfix"></div>
                <div style="margin-top: 25px;">
                  <p class="text-center"><a class="btn btn-alpata"
                      href="https://bayi.citroen.com.tr/citroenalpata/?location=Eski%C5%9Fehir" target="_blank">WEB
                      SİTESİ</a></p>
                </div>
              </div>
              <div class="col-md-3">
                <h2 class="text-center"><strong>OPEL</strong></h2>
                <div class="company-social" style="margin-top:25px;">
                  <a href="https://www.facebook.com/opelalpata" target="_blank" class="alp-social"><i
                      class="fa fa-facebook"></i></a>
                  <a href="https://www.instagram.com/opelalpata/" target="_blank" class="alp-social"><i
                      class="fa fa-instagram"></i></a>
                </div>

                <div class="clearfix"></div>
                <div style="margin-top: 25px;">
                  <p class="text-center"><a class="btn btn-alpata" href="https://opel.alpata.com/" target="_blank">WEB
                      SİTESİ</a></p>
                </div>
              </div>
              <div class="col-md-3">
                <h2 class="text-center"><strong>SPOTİCAR </strong></h2>
                <div class="company-social" style="margin-top:25px;">
                  <a href="https://www.facebook.com/Spoticar-Alpata-101300115770772 " target="_blank"
                    class="alp-social"><i class="fa fa-facebook"></i></a>
                  <a href="https://www.instagram.com/spoticaralpata/ " target="_blank" class="alp-social"><i
                      class="fa fa-instagram"></i></a>
                </div>

                <div class="clearfix"></div>
                <div style="margin-top: 25px;">
                  <p class="text-center"><a class="btn btn-alpata" href="https://www.spoticar.com.tr/ "
                      target="_blank">WEB
                      SİTESİ</a></p>
                </div>
              </div>
              <div class="clearfix"></div>

            </div>
          </div>
        </div>


      </div>
      <div class="container">
        <div class="preview-footer text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(2)">×</a>
        </div>
      </div>
      <!--End container -->

    </div>

  </div>

  <div *ngIf="gosterilenIsleme == 3" id="sigorta">
    <div class="project-preview">

      <div class="container">

        <div class="preview-header text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(3)">×</a>
          <h1 class="preview-title">ALPATA SİGORTA ARACILIK HİZMETLERİ LTD. ŞTİ.</h1>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <img class="img-responsive" style=" margin-bottom:30px;" src="assets/images/company/alpata-sigorta.png">
          </div>
        </div>

        <div class="imac-frame hidden">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>

        </div>
      </div>

      <div
        style="width: 100%; position: relative; background-size: cover; background-position: center center; color: black; background-image: url(assets/images/company/2073de91-8cbe-4d99-adea-6305b30c2184_BG.png);"
        id="bgCompany">
        <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay">
        </div>
        <div class="container">

          <div class="row">
            <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
              <p>
              </p>
              <p>1995 yılında kurulan ve Anadolu Sigorta acenteliği ile faaliyete başlayan Alpata Sigorta, sonrasında
                Allianz, Axa, Gulf, Mapfre, Groupama, AkSigorta, Sompo Japan, Acıbadem Sigorta, HDI, Halk Sigorta ve
                Türkiye Sigorta yetkili
                acenteliklerini de portföyüne eklemiştir.</p>

              <p>Türkiye'deki en büyük genel sigorta ürünleri aracılarından biri olan Alpata Sigorta; oto-kaza branşının
                yanı sıra, sağlık sigortalarında yüksek bilgi birikimine sahip olmakla birlikte havacılık, mühendislik
                ve sorumluluk sigortaları
                gibi uzmanlık bilgisi gerektiren alanlarda da hizmet vermekte ve müşterilerine yüksek memnuniyet
                sunmaktadır.
              </p>

              <p>Alpata Sigorta’nın acentelik hizmeti sunduğu geniş portföyünde yer alan ürünler aşağıdaki gibi
                sayılabilir.
              </p>

              <ul>
                <li>Araç &nbsp;Sigortaları</li>
                <li>Sağlık Sigortası</li>
                <li>Konut Sigortası</li>
                <li>Hayat Sigortası</li>
                <li>Ferdi Kaza Sigortası</li>
                <li>İşyeri Sigortası</li>
                <li>Yangın Sigortası</li>
                <li>Nakliyat Sigortaları</li>
                <li>Sorumluluk Sigortaları</li>
                <li>Mühendislik Sigortaları</li>
                <li>Havacılık Sigortaları</li>
                <li>Seyehat Sigortaları</li>
                <li>DASK (Zorunlu Deprem Sigortası)</li>
                <li>Eğitim Sigortası</li>
              </ul>



              <div class="bs-example bs-example-tabs" style="padding-top:15px;" id="filter-works">
                <ul id="myTab_13" role="tablist">
                  <div id="myTabContent_13" class="tab-content"></div>
                </ul>


              </div>
              <div class="clearfix"></div>

              <div class="row text-center">


              </div>

              <div class="clearfix"></div>

              <div class="company-social" style="margin-top:25px;">
                <a href="https://www.facebook.com/AlpataSigorta/" target=" _blank" class="alp-social"><i
                    class="fa fa-facebook"></i></a>
                <a href="https://www.instagram.com/alpatasigorta/" target="_blank" class="alp-social"><i
                    class="fa fa-instagram"></i></a>
              </div>
              <div class="clearfix"></div>
              <div style="margin-top: 25px;">
                <p class="text-center"><a class="btn btn-alpata" href="http://www.alpatasigorta.com/"
                    target="_blank">WEB SİTESİ</a></p>
              </div>

              <div class="clearfix"></div>


            </div>
          </div>
        </div>


      </div>
      <div class="container">
        <div class="preview-footer text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(3)">×</a>
        </div>
      </div>
      <!--End container -->

    </div>
  </div>
  <div *ngIf="gosterilenIsleme == 4" id="havacilik">
    <div class="project-preview">

      <div class="container">

        <div class="preview-header text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(4)">×</a>
          <h1 class="preview-title">ALP HAVACILIK SANAYİ VE TİCARET A.Ş.</h1>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <img class="img-responsive" style=" margin-bottom:30px;" src="assets/images/company/tesisler.png"></div>
        </div>

        <div class="imac-frame hidden" style="display: none;">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>

        </div>
      </div>

      <div
        style="width: 100%; position: relative; background-size: cover; background-position: center center; color: black; background-image: url(assets/images/company/cbb2a481-ddfc-4850-88ff-95b98b4efeef_BG.png);"
        id="bgCompany">
        <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay">
        </div>
        <div class="container">

          <div class="row">
            <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">

              <p>
              </p>
              <p>Alp Havacılık 1998 yılında Eskişehir’de kurulmuş, Havacılık ve Uzay sanayisine özgü ve bu sanayinin
                yüksek teknoloji, kalite, tasarım, mühendislik ve üretim standartları altında, dünyanın değişik
                bölgelerindeki müşterileri
                için uçuş kritik/döner komponent, alt sistem ve sistem imalatı yapan bir özel teşebbüs firmasıdır.</p>

              <p>Alp Havacılık sayısı 1300 e yaklaşan yüksek nitelikli personeli, iki yüzün üzerinde yeni nesil çok
                eksenli takım tezgahı, CMM kalite kontrol teçhizatları, tahribatsız muayene de dahil olmak üzere çeşitli
                test kabiliyetleri,
                kaplama, özel proses ve geniş çaplı laboratuvar kabiliyetleri ile hizmet vermektedir. Ayrıca, Alp
                Havacılık bir kısmı dünyada çok az tesiste bulunan ve tamamı NADCAP ve OEM müşterileri tarafından onaylı
                70’in üzerinde özel
                proses kabiliyetini de çatısı altında bulundurmaktadır.</p>

              <p>Alp Havacılık, etkin şekilde faaliyet gösteren tedarik zinciriyle birlikte titanyum, aluminyum, çelik,
                paslanmaz çelik, bakır alaşımları ve süper alaşımların işlenmesinde geniş çaplı deneyime sahiptir. Alp
                Havacılık dünyanın
                havacılık devleri arasında yer alan Lockheed Martin (Sikorsky, LM Aero), Raytheon Technologies (Pratt &
                Whitney, Pratt & Whitney Canada, Collins Aerospace (UTC Aerospace Systems, HS & GLG & Actuation
                Systems)), Heroux Devtek,
                Honeywell, Boeing, TEI TUSAŞ Motor Sanayii A.Ş, Türk Havacılık ve Uzay Sanayi ve Aselsan gibi
                müşterileri için Helikopter Dinamik Parçaları ve Asambleleri, Dişli ve Dişli Kutuları, Helikopter Kuyruk
                Pervanesi Sürücü Mili
                Sistemi (TRDS) Parçaları ve Asambleleri, jet motorlarında kullanılan Yekpare Fan ve Kompresor Rotoru
                (IBR-Integraly Bladed Rotors) dahil olmak üzere Dinamik ve Statik Motor ve APU Sistem bileşenleri, İniş
                Takımları, Uçak
                Yapısal Parçaları ve Asambleleri, Hidrolik ve Yakıt Boru Sistemleri üretimini gerçekleştirmektedir.</p>

              <p>Alp Havacılık tarafından üretilen ürünler; Black Hawk, Seahawk, S76, S92, CH53, CH47, F-35, F-22,
                Boeing 737, Boeing 747, Boeing 767, Boeing 777, Boeing 787, Airbus 320, Airbus 330, Airbus 340, Airbus
                380, Airbus A400M, gibi
                hava platformları ve F135, F100, P&W GTF Engines, PW150, PW305, PW530, PW535, PW545, PW600 gibi motor
                programlarında kullanılmaktadır. Üretim programlarına ilave olarak TEI tarafından özgün olarak
                geliştirilen TS1400 motoruna
                ait aksesuar dişli kutusunun tasarımı, geliştirilmesi ve üretiminde de ana yüklenici olarak faaliyet
                gösterilmektedir. Bu kapsamda tasarlanan ve üretilen ilk Aksesuar Dişli Kutusu 2021 yılında TEI ye
                teslim edilmiştir.</p>

              <p>Alp Havacılık, etkin ve verimli operasyonları ve Endüstri 4.0 uygulamaları ile müşterileri için en iyi
                değeri sağlarken, Nikel alaşımların işlenmesi için özel olarak geliştirdiği ve patent altına aldığı
                “seramik kesiciler”
                ile klasik üretim yöntemlerine göre ciddi oranda maliyet avantajı sağlayabilmektedir.</p>

              <p>Alp Havacılık 14 Kasım 2013 tarihi itibarı ile AR-GE merkezi olmuştur.</p>
              <p></p>
              <div class="bs-example bs-example-tabs" style="padding-top:15px;" id="filter-works">
                <ul id="myTab_14" role="tablist">
                  <div id="myTabContent_14" class="tab-content"></div>
                </ul>


              </div>
              <div class="clearfix"></div>

              <div class="row text-center">


              </div>

              <div class="clearfix"></div>

              <div class="company-social" style="margin-top:25px;">
                <a href="https://www.facebook.com/alphavacilik" target="_blank" class="alp-social"><i
                    class="fa fa-facebook"></i></a>
                <a href="https://twitter.com/alp_havacilik" target="_blank" class="alp-social"> <svg viewBox="0 0 24 24"
                    aria-label="X" role="img" style="
                    fill: #0F1D41; width: 32px; margin-bottom: -5px;">
                    <g>
                      <path
                        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z">
                      </path>
                    </g>
                  </svg></a>
                <a href="https://www.linkedin.com/company/alp-havac%C4%B1l%C4%B1k" target="_blank" class="alp-social"><i
                    class="fa fa-linkedin"></i></a>
                <a href="https://www.youtube.com/channel/UCJb2rOaWiF7rC8BC8QjxNlw" target="_blank" class="alp-social"><i
                    class="fa fa-youtube"></i></a>
                <a href="https://www.instagram.com/alp_havacilik/" target="_blank" class="alp-social"><i
                    class="fa fa-instagram"></i></a>
              </div>

              <div class="clearfix"></div>

              <div style="margin-top: 25px;">
                <p class="text-center"><a class="btn btn-alpata" href="http://www.alp.com.tr " target="_blank">WEB
                    SİTESİ</a></p>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div class="container">
        <div class="preview-footer text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(4)">×</a>
        </div>
      </div>
      <!--End container -->

    </div>
  </div>
  <div *ngIf="gosterilenIsleme == 5" id="teknoloji">
    <div class="project-preview">

      <div class="container">

        <div class="preview-header text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(5)">×</a>
          <h1 class="preview-title">NECDET ALPATA A.Ş. TEKNOLOJİ ŞUBESİ</h1>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <img class="img-responsive" style=" margin-bottom:30px;" src="assets/images/company/Alpata-Teknoloji.png">
          </div>
        </div>

        <div class="imac-frame hidden" style="display: none;">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>

        </div>
      </div>

      <div
        style="width: 100%; position: relative; background-size: cover; background-position: center center; color: black; background-image: url(assets/images/company/b15c2ea5-5819-45f9-a196-4fbca8860f6c_BG.png);"
        id="bgCompany">
        <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay">
        </div>
        <div class="container">

          <div class="row">
            <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
              <p>
              </p>
              <p>Alpata Grubu 2000 yılında Necdet Alpata A.Ş. Teknoloji Şubesini, bünyesine kattı. Necdet Alpata A.Ş.
                Teknoloji Şubesi, 40
                kişilik kadrosuyla
                Eskişehir Teknokent merkezi ve Ankara Şubesi ile tüm Türkiye’ye hizmet vermektedir. KOBİ'lere, büyük
                endüstri şirketlerine,
                kamu kurum ve kuruluşlarına, ticaret odaları ve borsalarına bilgi teknolojileri ve yazılım çözümlerinin
                yerli olanaklarla üretimini amaçlamaktadır. Necdet Alpata A.Ş. Teknoloji Şubesi, TÜBİTAK (Türkiye
                Bilimsel ve Teknolojik
                Araştırma Kurumu)
                ve Avrupa Birliği desteğine layık görülen projelerle Alpata Grubu’nu daha da ileriye götürme planlarının
                yapıldığı bir araştırma-geliştirme üssü konumundadır.
              </p>

              <p>Necdet Alpata A.Ş. Teknoloji Şubesinin geliştirdiği Borsa Bilgi Sistemleri Yazılımı ise bugün
                Türkiye’de
                bulunan 113
                Ticaret Borsası’nın büyük bölümünde kullanılmakta ve Ticaret Borsaları’nın tüm iş süreçleri bu yazılım
                üzerinden entegre olarak
                takip edilmektedir. </p>

              <p>5300 sayılı Lisanslı Depoculuk kanunu kapsamında kurulan lisanslı depolar, Necdet Alpata A.Ş. Teknoloji
                Şubesi’nin
                geliştirdiği ve lisanslı depoların iş süreçlerini yönetmek üzere tasarladığı lisanslı depoculuk
                otomasyon sistemi yazılımını kullanmaktadır.</p>

              <p>Necdet Alpata A.Ş. Teknoloji Şubesi, bilginin kullanımı, paylaşılması ve geliştirilmesi konusunda tüm
                Alpata Grubu
                çalışanlarını ilgili sektörlerdeki son gelişmelerle buluşturarak farklı misyonu da yerine getirmektedir.
              </p>

              <p></p>




              <div class="bs-example bs-example-tabs" style="padding-top:15px;" id="filter-works">
                <ul id="myTab_15" role="tablist">
                  <div id="myTabContent_15" class="tab-content"></div>
                </ul>


              </div>
              <div class="clearfix"></div>

              <div class="row text-center">


              </div>

              <div class="clearfix"></div>

              <div class="company-social" style="margin-top:25px;">
                <a href="https://www.facebook.com/alpatayazilim" target="_blank" class="alp-social"><i
                    class="fa fa-facebook"></i></a>
                <a href="https://twitter.com/alpatayazilim" target="_blank" class="alp-social"> <svg viewBox="0 0 24 24"
                    aria-label="X" role="img" style="
                    fill: #0F1D41; width: 32px; margin-bottom: -5px;">
                    <g>
                      <path
                        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z">
                      </path>
                    </g>
                  </svg></a>
                <a href="https://www.linkedin.com/company/alpata-yaz-l-m-ve-teknoloji" target="_blank"
                  class="alp-social"><i class="fa fa-linkedin"></i></a>
                <a href="https://www.instagram.com/alpatayazilim/" target="_blank" class="alp-social"><i
                    class="fa fa-instagram"></i></a>
              </div>

              <div class="clearfix"></div>

              <div style="margin-top: 25px;">
                <p class="text-center"><a class="btn btn-alpata" href="http://www.alpatateknoloji.com"
                    target="_blank">WEB
                    SİTESİ</a></p>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div class="container">
        <div class="preview-footer text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(5)">×</a>
        </div>
      </div>
      <!--End container -->

    </div>
  </div>
  <div *ngIf="gosterilenIsleme == 6" id="alpteknik">
    <div class="project-preview">

      <div class="container">

        <div class="preview-header text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(6)">×</a>
          <h1 class="preview-title">ALPTEKNİK HAVACILIK SANAYİ VE TİCARET A.Ş.</h1>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <img class="img-responsive" style=" margin-bottom:30px;"
              src="assets/images/company/Alpteknik-havacılık.png">
          </div>
        </div>

        <div class="imac-frame hidden" style="display: none;">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>

        </div>
      </div>

      <div
        style="width: 100%; position: relative; background-size: cover; background-position: center center; color: black; background-image: url(assets/images/company/9fd40c5f-aa8d-4da2-8cec-85374ab956e2_BG.png);"
        id="bgCompany">
        <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay">
        </div>
        <div class="container">

          <div class="row">
            <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
              <p>
              </p>
              <p>Eskişehir’de yerleşik Alp Havacılık’ın iştiraki olarak 2013 yılında kurulan Alpteknik Havacılık Sanayi
                ve Ticaret A.Ş. Ankara’da satış sonrası hizmetler konusunda faaliyetlerini yürütmektedir. Alpteknik, bir
                Lockheed Martin
                şirketi olan Sikorsky Aircraft Corporation tarafından, Sikorsky sabit ve döner kanatlı hava araçlarının
                yedek parça, aksesuar ve aparatları ile bunlara ait revizyon ve tamir gereksinimleri konusunda tek
                yetkili Türkiye
                distribütörü olarak tayin edilmiştir.</p>

              <p>Sikorsky S-76, S-92, S-61 ve M28 ticari hava araçlarının, Türkiye’de ve Merkez Asya’da Satış
                Danışmanıdır.
              </p>

              <p>Alpteknik Havacılık, Türkiye ve Orta Asya’da bulunan, yeni ve kullanılmış Sikorsky platformlarının
                ticari işleticilerine de yedek parça tedarikçisi olarak hizmet vermektedir. Alpteknik Havacılık
                müşterilerine Ankara’daki merkezi,
                Eskişehir ve İzmir Serbest Ticaret Bölgesi’ndeki şubeleri vasıtası ile etkin hizmet vermektedir..</p>



              <p></p>




              <div class="bs-example bs-example-tabs" style="padding-top:15px;" id="filter-works">
                <ul id="myTab_16" role="tablist">
                  <div id="myTabContent_16" class="tab-content"></div>
                </ul>


              </div>
              <div class="clearfix"></div>

              <div class="row text-center">


              </div>

              <div class="clearfix"></div>

              <div class="company-social" style="margin-top:25px;">
                <a href="https://www.facebook.com/AlpJet/" target="_blank" class="alp-social"><i
                    class="fa fa-facebook"></i></a>
                <a href="https://twitter.com/alpjet" target="_blank" class="alp-social"> <svg viewBox="0 0 24 24"
                    aria-label="X" role="img" style="
                    fill: #0F1D41; width: 32px; margin-bottom: -5px;">
                    <g>
                      <path
                        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z">
                      </path>
                    </g>
                  </svg></a>
                <a href="https://www.linkedin.com/alpjet" target="_blank" class="alp-social"><i
                    class="fa fa-linkedin"></i></a>
                <a href="https://www.instagram.com/alpjet/" target="_blank" class="alp-social"><i
                    class="fa fa-instagram"></i></a>
              </div>

              <div class="clearfix"></div>

              <div style="margin-top: 25px;">
                <p class="text-center"><a class="btn btn-alpata" href="http://www.alptechnic.com" target="_blank">WEB
                    SİTESİ</a></p>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div class="container">
        <div class="preview-footer text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(6)">×</a>
        </div>
      </div>
      <!--End container -->

    </div>
  </div>
  <div *ngIf="gosterilenIsleme == 7" id="alpatasrl">
    <div class="project-preview">

      <div class="container">

        <div class="preview-header text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(7)">×</a>
          <h1 class="preview-title">ALPATA S.R.L</h1>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <img class="img-responsive" style=" margin-bottom:30px;" src="assets/images/company/Alpata-SRL.png">
          </div>
        </div>

        <div class="imac-frame hidden" style="display: none;">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>

        </div>
      </div>

      <div
        style="width: 100%; position: relative; background-size: cover; background-position: center center; color: black; background-image: url(assets/images/company/AlpataSRL_BG.png);"
        id="bgCompany">
        <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay">
        </div>
        <div class="container">

          <div class="row">
            <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify; padding-top:50px;">
              <p>
              </p>
              <p>Alpata SRL, 2019 yılından bu yana İtalya'da faaliyet gösteren ve dünyanın en önemli yüksek alaşım metal
                üreticilerine tedarik sağlayan global bir şirkettir. </p>

              <p>Şirketimiz, havacılık ve savunma sanayisinde kullanılan yüksek hız ve yüksek ısıya dayanıklı metallerin
                hurda ticaretini yapmaktadır. Amacımız, müşterilerimize maksimum karlılığa ulaştırmak ve sektördeki
                ihtiyaçları karşılamaktır.
              </p>
              <!--
                            <p>Alpteknik Havacılık, Türkiye ve Orta Asya’da bulunan, yeni ve kullanılmış Sikorsky platformlarının ticari işleticilerine de yedek parça tedarikçisi olarak hizmet vermektedir. Alpteknik Havacılık müşterilerine Ankara’daki merkezi,
                                Eskişehir ve İzmir Serbest Ticaret Bölgesi’ndeki şubeleri vasıtası ile etkin hizmet vermektedir.</p> -->
              <p></p>
              <div class="bs-example bs-example-tabs" style="padding-top:15px;" id="filter-works">
                <ul id="myTab_16" role="tablist">
                  <div id="myTabContent_16" class="tab-content"></div>
                </ul>


              </div>
              <div class="clearfix"></div>

              <div class="row text-center">


              </div>

              <div class="clearfix"></div>

              <div class="company-social" style="margin-top:25px;">
                <!-- <a href="https://www.facebook.com/AlpJet/" target="_blank" class="alp-social"><i
                    class="fa fa-facebook"></i></a> -->
                <!-- <a href="https://twitter.com/alpjet" target="_blank" class="alp-social"><i
                    class="fa fa-twitter"></i></a> -->
                <a href="https://www.linkedin.com/company/alpatasrl" target="_blank" class="alp-social"><i
                    class="fa fa-linkedin"></i></a>
                <!-- <a href="https://www.instagram.com/alpjet/" target="_blank" class="alp-social"><i
                    class="fa fa-instagram"></i></a> -->
              </div>

              <div class="clearfix"></div>

              <div style="margin-top: 25px;">
                <p class="text-center"><a class="btn btn-alpata" href="https://alpatametalli.it/" target="_blank">WEB
                    SİTESİ</a></p>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div class="container">
        <div class="preview-footer text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(7)">×</a>
        </div>
      </div>
      <!--End container -->

    </div>
  </div>
  <div *ngIf="gosterilenIsleme == 8" id="alpatasrl">
    <div class="project-preview">

      <div class="container">

        <div class="preview-header text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(8)">×</a>
          <h1 class="preview-title">ALPATA HAVACILIK</h1>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <img class="img-responsive" style=" margin-bottom:30px;"
              src="assets/images/company/Alpata-havacilik-banner-tr.png">
          </div>
        </div>

        <div class="imac-frame hidden" style="display: none;">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>

        </div>
      </div>

      <div
        style="width: 100%; position: relative; background-size: cover; background-position: center center; color:black; background-image: url(assets/images/company/Alpata-havacilik_BG.png);"
        id="bgCompany">
        <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay">
        </div>
        <div class="container">

          <div class="row">
            <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify; padding-top:50px;">
              <p>
              </p>
              <p>Eskişehir Organize Sanayi Bölgesinde 2024 yılında kurulan firmamız, hava taşıtları ve savunma sanayi
                parçalarına yönelik talaşlı imalat yöntemi ile üretim yapmaktadır. Firmamız 7.000 m² açık alan üzerine
                kurulmuş olup, 1.700 m² kapalı alanında güçlü makine parkı ile hizmet vermektedir. </p>
              <p>Firmamız
                güvenilirlik, dürüstlük ve kaliteyi esas alarak müşteri memnuniyetini sağlamayı ilke edinmiştir.
                Teknolojiyi ve yenilikleri yakından takip eden firmamız her zaman daha iyi, hızlı ve kaliteli olmayı
                amaçlamaktadır.
              </p>
              <p></p>
              <div class="bs-example bs-example-tabs" style="padding-top:15px;" id="filter-works">
                <ul id="myTab_16" role="tablist">
                  <div id="myTabContent_16" class="tab-content"></div>
                </ul>


              </div>
              <div class="clearfix"></div>

              <div class="row text-center">


              </div>

              <div class="clearfix"></div>

              <div class="company-social" style="margin-top:25px;">
                <a href="https://www.facebook.com/profile.php?id=61553670151388" target="_blank" class="alp-social"><i
                    class="fa fa-facebook"></i></a>
                <a href="https://twitter.com/alpatahavacilik" target="_blank" class="alp-social"> <svg
                    viewBox="0 0 24 24" aria-label="X" role="img" style="
                    fill: #0F1D41; width: 31px; margin-bottom: -5px;">
                    <g>
                      <path
                        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z">
                      </path>
                    </g>
                  </svg></a>
                <a href="https://www.linkedin.com/company/alpata-havac%C4%B1l%C4%B1k/" target="_blank"
                  class="alp-social"><i class="fa fa-linkedin"></i></a>
                <a href="https://www.instagram.com/alpatahavacilik/" target="_blank" class="alp-social"><i
                    class="fa fa-instagram"></i></a>
              </div>

              <div class="clearfix"></div>

              <div style="margin-top: 25px;">
                <p class="text-center"><a class="btn btn-alpata" href="https://alpatahavacilik.com.tr/"
                    target="_blank">WEB
                    SİTESİ</a></p>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div class="container">
        <div class="preview-footer text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(8)">×</a>
        </div>
      </div>
      <!--End container -->

    </div>
  </div>
  <!-- End Row -->


  <!-- End Projects Container -->



  <!-- End container -->
  <!--==== Project Preview Panel (DO NOT REMOVE)====-->

  <div id="preview-scroll"></div>

  <div id="project-preview">

    <div class="container">

      <div class="preview-header text-center">
        <a class="close-preview" href="#">&times;</a>
        <h1 class="preview-title"></h1>
        <p class="preview-subtitle"></p>
      </div>

      <div class="imac-frame">
        <span class="loader"></span>
        <div class="imac-screen imac-slider flexslider"></div>

      </div>
    </div>

    <div style="width:100%; position: relative; background-size:cover; background-position:center; color:black;"
      id="bgCompany">
      <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay"></div>
      <div class="container">

        <div class="row">
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify"></div>
        </div>
      </div>


    </div>
    <div class="container">
      <div class="preview-footer text-center">
        <a class="close-preview" href="#">&times;</a>
      </div>
    </div>
    <!--End container -->

  </div>
  <!--End #project-preview panel-->

</section>
<section id="hr" class="white-bg padding-top-bottom">

  <div class="container">

    <h1 class="section-title">KARİYER</h1>
    <div class="row">
      <!--=== Contact Form ===-->

      <form class="forms-sample contact-form col-md-6 col-sm-offset-3" (submit)="ekleGuncelle(0)" ngNativeValidate>
        <div class="row">
          <div class="form-group">
            <div class=" controls">
              <select id="contact-company" name="SirketTipi" placeholder="Şirket Seçiniz" required="true"
                [(ngModel)]="item.SirketTipi" class="form-control requiredField label_better">
                <option value="">Şirket Seçiniz</option>
                <option value="0">NECDET ALPATA PAZARLAMA LOJİSTİK VE TURİZM SANAYİ VE TİCARET A.Ş.
                </option>
                <option value="1">NECDET ALPATA A.Ş. OTOMOTİV ŞUBESİ</option>
                <option value="2">ALPATA SİGORTA ARACILIK HİZMETLERİ LTD. ŞTİ.</option>
                <option value="3">ALP HAVACILIK SANAYİ VE TİCARET A.Ş.</option>
                <option value="4">NECDET ALPATA A.Ş. TEKNOLOJİ ŞUBESİ
                </option>
                <option value="5">ALPTEKNİK HAVACILIK SANAYİ VE TİCARET A.Ş.</option>
                <option value="6">ALPATA S.R.L</option>
                <option value="7">ALPATA HAVACILIK SANAYİ VE TİCARET A.Ş.</option>
              </select>
              <i class="fa fa-building-o"></i>
            </div>
          </div>
          <div class="form-group">
            <input type="text" class="form-control" id="Ad" name="Ad" autocomplete="off" placeholder="İsim"
              [(ngModel)]="item.Ad" required="true" />
            <i class="fa fa-user"></i>
          </div>
          <div class="form-group">
            <input type="text" class="form-control" id="Soyad" name="Soyad" autocomplete="off" placeholder="Soyisim"
              [(ngModel)]="item.Soyad" required="true" />
            <i class="fa fa-user"></i>
          </div>
          <div class="form-group">
            <input type="text" class="form-control" id="Email" name="Email" autocomplete="off" placeholder="E-posta"
              [(ngModel)]="item.Email" required="true" />
            <i class="fa fa-envelope"></i>
          </div>
          <div class="form-group">
            <input type="text" class="form-control" id="Telefon" name="Telefon" autocomplete="off" placeholder="Telefon"
              [(ngModel)]="item.Telefon" required="true" />
            <i class="fa fa-phone"></i>
          </div>
          <div class="form-group">
            <i class="fa fa-file-o"></i>
            <input type="file" class="form-control" id="file" (change)="handleFileInput($event.target.files)">
          </div>

          <div class="form-check" style="margin-top:40px;margin-bottom:10px;text-align:center;">

            <label style=" font-size: 14px">
              <input type="checkbox" class="form-check-input requiredField" required="true" name="IsGDPR" id="IsGDPR">
              <a href="#" data-toggle="modal" data-target="#gdprModal" style="color: red;">
                Kişisel veri bilgi ve onay metni</a>'ni okudum,anladım ve kabul ediyorum.
            </label>
          </div>

          <div class="col-md-12">
            <button [disabled]="ekleGuncelleIsLoading" type="submit" class="btn btn-alpata btn-block">
              <span *ngIf="ekleGuncelleIsLoading" role="status" aria-hidden="true"></span>
              <i class="fa fa-location-arrow"></i>Gönder
            </button>
          </div>
        </div>
      </form>

      <!-- <form id="hr-form" class="col-sm-6 col-sm-offset-3" action="http://alpata.com/tr/Home/SendHRForm" method="post"
        enctype="multipart/form-data" novalidate>

        <div class="form-group">
          <label class="control-label" for="contact-mail">Şirket</label>
          <div class=" controls">
            <select id="contact-company" name="CompanyNo" class="form-control requiredField label_better"
              data-error-empty="Please select a company">
              <option value="">Şirket Se&#231;iniz</option>
              <option value="6">NECDET ALPATA PAZARLAMA LOJİSTİK VE TURİZM SANAYİ VE TİCARET A.Ş.</option>
              <option value="10">NECDET ALPATA A.Ş. OTOMOTİV ŞUBESİ</option>
              <option value="13">ALPATA SİGORTA ARACILIK HİZMETLERİ LTD. ŞTİ.</option>
              <option value="14">ALP HAVACILIK SANAYİ VE TİCARET A.Ş.</option>
              <option value="15">ALPATA TEKNOLOJİ YAZILIM ve BİLİŞİM HİZMETLERİ SAN. ve TİC. A.Ş</option>
              <option value="16">ALPTEKNİK HAVACILIK SANAYİ VE TİCARET A.Ş.</option>
            </select>
            <i class="fa fa-building-o"></i>
          </div>
        </div>

        <div class="form-group">
          <label class="control-label" for="contact-name">İsim</label>
          <div class="controls">
            <input id="contact-name" name="Name" placeholder="İsim" class="form-control requiredField label_better"
              type="text" data-error-empty="Please enter your name">
            <i class="fa fa-user"></i>
          </div>
        </div>

        <div class="form-group">
          <label class="control-label" for="contact-name">Soyisim</label>
          <div class="controls">
            <input id="contact-name" name="Surname" placeholder="Soyisim"
              class="form-control requiredField label_better" type="text" data-error-empty="Please enter your surname">
            <i class="fa fa-user"></i>
          </div>
        </div>


        <div class="form-group">
          <label class="control-label" for="contact-mail">E-posta</label>
          <div class=" controls">
            <input id="contact-mail" name="Email" placeholder="E-posta" class="form-control requiredField label_better"
              type="email" data-error-empty="Please enter your email" data-error-invalid="Invalid email address">
            <i class="fa fa-envelope"></i>
          </div>
        </div>

        <div class="form-group">
          <label class="control-label" for="contact-name">Telefon</label>
          <div class="controls">
            <input id="contact-phone" name="Phone" placeholder="Telefon" class="form-control label_better" type="text"
              data-error-empty="Please enter your phone number">
            <i class="fa fa-phone"></i>
          </div>
        </div>


        <div class="form-group">
          <label class="control-label" for="contact-message">CV Y&#252;kleyin (PDF, 5MB)</label>
          <div class="controls">
            <input type="file" name="cv" placeholder="Telefon" class="form-control label_better"
              data-error-empty="Please select a pdf file">
            <i class="fa fa-file-o"></i>
          </div>
        </div>
        <div class="form-check" style="margin-top:40px;margin-bottom:10px;text-align:center;">


          <label style=" font-size: 14px">
            <input type="checkbox" class="form-check-input requiredField" name="IsGDPR" id="IsGDPR">
            <a href="#" data-toggle="modal" data-target="#gdprModal" style="color: red;">
              Kişisel veri bilgi ve onay metni</a>'ni okudum,anladım ve kabul ediyorum.
          </label>
        </div>
        <p>
          <button name="submit" type="submit" id="btn-hrSubmit" disabled class="btn btn-alpata btn-block"
            data-error-message="Error!" data-sending-message="Gönderiliyor..."
            data-ok-message="CVniz tarafımıza iletildi">
            <i class="fa fa-location-arrow"></i>G&#246;nder
          </button>
        </p>

        <input type="hidden" name="submitted" id="submitted" value="true" />

      </form> -->
      <!-- End contact-form -->
    </div>
  </div>

</section>
<!-- Modal -->
<div id="gdprModal" class="modal fade" role="dialog" style="z-index: 9999">
  <div class="modal-dialog modal-lg">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title">&nbsp;</h4>
      </div>
      <div class="modal-body">
        <p><strong>6698 SAYILI KİŞİSEL VERİLERİN KORUNMASI KANUNU VE BU KANUN KAPSAMINDAKİ HAKLARINIZ İLE İLGİLİ
            BİLGİLENDİRME, BEYAN ve ONAY FORMU</strong></p>

        <p>07.04.2016 tarihli ve 29677 sayılı Resmi Gazetede yayımlanan 6698 sayılı Kişisel Verilerin Korunması Kanunu
          (KVKK) uyarınca veri sorumlusu (VS) sıfatına haiz şirketimiz tarafından elde edilmiş/edilecek ya da
          şirketimizle paylaştığınız/paylaşacağınız
          şahsınıza ait her t&uuml;rl&uuml; bilginin (kişisel veri), aşağıda a&ccedil;ıklanan &ccedil;er&ccedil;evede ve
          KVKK&rsquo;da &ouml;ng&ouml;r&uuml;len şekillerde şirketimizce işleneceği ve bilgilerinizin otomatik olan ya
          da olmayan
          yollarla elde edilmesi, kaydedilmesi, depolanması, a&ccedil;ıklanması, aktarılması, elde edilebilir hale
          getirilmesi de dahil olmak &uuml;zere bilgileriniz &uuml;zerinde ger&ccedil;ekleştirilen her t&uuml;rl&uuml;
          işlemin &ldquo;kişisel
          verilerin işlenmesi&rdquo; anlamına geldiğini bilgilerinize sunarız.</p>

        <p><strong>KİŞİSEL VERİLERİN İŞLENME AMA&Ccedil;LARI VE HUKUKİ SEBEPLERİ</strong></p>

        <p>Başta İş, İş Sağlığı ve G&uuml;venliği, Sosyal Sigortalar ve Genel Sağlık Sigortası olmak &uuml;zere t&uuml;m
          ulusal/uluslararası mevzuat ve/veya bunlara dayalı olarak Bakanlık ve diğer yetkili otoritelerce yayımlanmış
          olan ikincil d&uuml;zenlemelerle,
          şirketimizin faaliyetleri ile ilgili olarak taraf olduğu/olacağı s&ouml;zleşmeler kapsamında şirketimizin
          g&uuml;venlik, prensip, prosed&uuml;r, ilke, y&uuml;k&uuml;ml&uuml;l&uuml;k ve taahh&uuml;tlerin yerine
          getirilmesi (personel
          kayıtları, kimlik tespiti, bilgi saklama, raporlama, bilgilendirme, asıl işveren
          y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml;, otopark kayıtları, kamera g&ouml;r&uuml;nt&uuml;leri, mali belge
          d&uuml;zenleme, vb.) ile s&ouml;zleşmeler mucibince
          gerekli kayıt ve belgelerin d&uuml;zenlenmesi, hizmet ve y&uuml;k&uuml;ml&uuml;l&uuml;klerin kesintisiz
          eksiksiz olarak yerine getirilmesi ve s&uuml;rd&uuml;r&uuml;lmesi, taleplerinizin karşılanması, pazarlama ve
          Reklam faaliyetlerinin
          y&uuml;r&uuml;t&uuml;lmesi vb. sebeplerle &ouml;zel nitelikli kişisel verileriniz de dahil olmak &uuml;zere
          şirketimizce işlenmektedir.</p>

        <p><strong>KİŞİSEL VERİLERİN TOPLANMA Y&Ouml;NTEMİ VE HUKUKİ SEBEBİ</strong></p>

        <p>Yukarıda a&ccedil;ıklanan sebeplerle kişisel verileriniz şirketimiz &ccedil;alışanları, internet sitesi,
          &ccedil;ağrı merkezi (operat&ouml;r) ve benzeri diğer t&uuml;m işleyen/işleyecek kanallarla otomatik ya da
          otomatik olmayan yollarla
          s&ouml;zl&uuml;, yazılı ve elektronik olarak toplanabilmektedir.</p>

        <p>Bu kapsamda; isim ve soyisminiz, T&uuml;rkiye Cumhuriyeti kimlik, vergi numaranız, T.C. kimlik bilgileriniz,
          t&uuml;zel kişi ortaklık bilgileriniz/yetki sınırlarınız, pasaport, s&uuml;r&uuml;c&uuml;- iş makinası
          operat&ouml;r&uuml;- iş
          yeterlilik vb belgeleriniz, eğitim/kurs belge ve bilgileriniz, ara&ccedil; ruhsat bilgileriniz, arşiv
          araştırma formu, adli sicil kaydı, fotoğraf, sağlık raporu, biyometrik ve genetik verileriniz, işyeri kamera
          g&ouml;r&uuml;nt&uuml;leri,
          &ouml;deme-banka ve kredi kartı bilgileriniz, iletişim numalarınız ve adresiniz, işyeri ve alışveriş
          bilgileriniz, iş sağlığı ve g&uuml;venliği a&ccedil;ısından gerekli belgeleriniz ve bunlarla sınırlı olmamak
          &uuml;zere &ouml;zel
          ve/veya &ouml;zel olmayan kişisel verileriniz toplama,işleme,depolama, kaydetme, a&ccedil;ıklama, aktarma ve
          elde edilebilir hale getirilmektedir.
        </p>

        <p>Yine &uuml;&ccedil;&uuml;nc&uuml; kişiler (iş-iş&ccedil;i bulma faaliyeti y&uuml;r&uuml;ten web siteleri ve
          kurum/kuruluşlar, kişisel veri sahibi ile arasında m&uuml;n&rsquo;akid s&ouml;zleşme olan kurum/kuruluşlar,
          &ccedil;ağrı merkezleri,
          kişisel veri sahibinin şirketimizde yapacağı faaliyeti organize eden/sağlayan kurum/kuruluşlar, anlaşmalı
          destek hizmet sağlayıcılarından, şirketimiz yurt i&ccedil;i ve yurt dışı ortaklarından, internet sitemize
          yapmış olduğunuz ziyaret
          esnasında oluşan &ccedil;erezlerden vb) yukarıda belirtilen &ouml;zel nitelikli kişisel veriler dahil olmak
          &uuml;zere her t&uuml;rl&uuml; kişisel veriniz toplama,işleme,depolama, kaydetme, a&ccedil;ıklama, aktarma ve
          elde edilebilir
          hale getirilmektedir.</p>

        <p><strong>KIŞISEL VERILERIN AKTARILABİLECEĞİ KİŞİ YADA KURULUŞLAR</strong></p>

        <p>T&uuml;m ulusal/uluslararası mevzuat ve/veya bunlara dayalı olarak Bakanlık ve diğer yetkili otoritelerce
          yayımlanmış olan ikincil d&uuml;zenlemelerle, şirketimizin faaliyetleri ile ilgili olarak taraf olduğu/olacağı
          s&ouml;zleşmeler kapsamında
          kişisel bilgileri işleme izin-hak ve yetkisine sahip kişi/kuruluşlar ile grup şirketlerimiz başta olmak
          &uuml;zere şirketimizin yurt i&ccedil;i/dışındaki ortakları, şirketimizce hizmet/destek/danışmanlık alınan ya
          da işbirliği yapılan
          kişi/kurum/kuruluşlara aktarılabilecektir.</p>

        <p><strong>ELEKTRONIK İLETILER</strong></p>

        <p>Kabul etmiş olmanız halinde size doğrudan (&ouml;r. telefon, e-posta, SMS, sosyal ağlar, posta) bilgilendirme
          vs. i&ccedil;in g&uuml;ncellemeler ve teklifler sunabiliriz. Bu &ccedil;er&ccedil;evede diğer kişisel
          verilerinizi de kullanabiliriz.</p>

        <p><strong>VERİ SAHİBİNİN HAKLARI</strong></p>

        <p>6698 sayılı Kişisel Verileri Koruma Kanunu&rsquo;nun 28. Maddesinde &ouml;ng&ouml;r&uuml;len haller saklı
          kalmak kaydıyla anılan kanunun 11. Maddesi kapsamında; Kişisel veri işlenip işlenmediğini &ouml;ğrenme,
          işlenmişse buna ilişkin bilgi
          talep etme, kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını
          &ouml;ğrenme, Yurt i&ccedil;inde veya yurt dışında kişisel verilerin aktarıldığı &uuml;&ccedil;&uuml;nc&uuml;
          kişileri bilme, Kişisel
          verilerin eksik veya yanlış işlenmiş olması h&acirc;linde bunların d&uuml;zeltilmesini isteme, Kanun&#39;un 7
          nci maddesinde &ouml;ng&ouml;r&uuml;len şartlar &ccedil;er&ccedil;evesinde kişisel verilerin silinmesini veya
          yok edilmesini
          isteme ve bu kapsamda şirketimizce yapılan işlemlerinin bilgilerinin altarıldığı 3. Kişilere bildirilmesini
          talep etme, İşlenen verilerin m&uuml;nhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin
          kendisi aleyhine
          bir sonucun ortaya &ccedil;ıkmasına itiraz etme ve kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması
          h&acirc;linde zararın giderilmesini talep etme haklarına sahipsiniz.</p>

        <p>Bu madde kapsamında haklarınızı, d&uuml;zenlemenin y&uuml;r&uuml;rl&uuml;k tarihi olan 07.10.2016 tarihinden
          itibaren kullanmanız m&uuml;mk&uuml;n olup taleplerinizin yerine getirilmesini teminen şirketimizce yapılacak
          masrafları KVKK&rsquo;nın
          &ldquo;Veri Sorumlusuna Başvuru&rdquo; başlıklı 13. Maddesinde belirtilen tarifeye g&ouml;re tarafınızdan
          talep etme hakkımız saklıdır. Yukarıda anılan haklarınızı kullanmayı talep etmeniz halinde l&uuml;tfen&nbsp;
          <strong>alpatagida@alpata.com</strong> adresine eposta g&ouml;nderiniz.</p>

        <p><strong>ONAY</strong></p>

        <p>6698 sayılı KVKK&#39;na uygun olarak yukarıda a&ccedil;ıklanan bilgiler &ccedil;er&ccedil;evesinde şirketiniz
          ve/veya şirketiniz adına personeliniz, şubeleriniz, &ccedil;ağrı merkeziniz, bağlı şirketleriniz/ortaklarınız
          tarafından ya da
          internet siteleriniz ile sosyal medya sayfalarınız ve bunlarla sınırlı olmamak &uuml;zere her t&uuml;rl&uuml;
          kanallar aracılığı ile; kişisel ve/veya &ouml;zel nitelikli kişisel verilerimin; tamamen veya kısmen elde
          edilmesi, kaydedilmesi,
          depolanması, değiştirilmesi, g&uuml;ncellenmesi, periyodik olarak kontrol edilmesi, yeniden d&uuml;zenlenmesi,
          sınıflandırılması, Şirketinizin birlikte &ccedil;alıştığı ya da kanunen y&uuml;k&uuml;ml&uuml; olduğu kamu
          kurum ve kuruluşlarıyla
          ve/veya T&uuml;rkiye&#39;de veya yurt dışında mukim olan 3. kişilerle paylaşılması, yurtdışına aktarılması ya
          da kullanılmasının engellenmesi de dahil olmak &uuml;zere işlenmesine, onay, teklif, bilgilendirme vs.
          i&ccedil;in ticari
          elektronik iletiler ile tarafıma teklif/bilgilendirme yapılmasına konu hakkında teredd&uuml;de yer vermeyecek
          şekilde bilgi sahibi olarak, aydınlatılmış a&ccedil;ık rızam ile onay veriyorum.</p>

        <p>*Kişisel verilerinizin silinmesini talep etmeniz halinde kanunen tutulması zorunlu olan s&uuml;renin sonunda
          verileriniz silinecektir.</p>

        <p>Bilgilendirildim, Kabul Ediyorum.</p>

      </div>
    </div>
  </div>
</div>
<section id="contact" class="contact white-bg padding-top-bottom">

  <div class="container">

    <h2 class="section-title">İLETİŞİM</h2>
    <div class="row">


      <div class="col-sm-4 text-center contact-item scrollimation fade-right text-small in " style="font-size:9pt;">
        <a class="icon" target="_blank"><i style="font-size:20pt;" class="fa fa-map-marker fa-fw"></i></a>
        <h2 style="min-height:57px;">NECDET ALPATA PAZARLAMA LOJİSTİK VE TURİZM SANAYİ VE TİCARET A.Ş.</h2>
        <p style="min-height:72px;">Zafer Mahallesi Esener Sokak No:3 Tepebaşı Eskişehir </p>
        <strong>Tel:</strong> 0 (222) 323 89 00<br />
        <strong>Fax:</strong> 0 (222) 322 13 14<br /> &nbsp;
        <strong>Mail: </strong> info@alpata.com
        <br />
        <br />
      </div>
      <div class="col-sm-4 text-center contact-item scrollimation fade-right text-small in " style="font-size:9pt;">
        <a class="icon" href="https://opel.alpata.com/" target="_blank"><i style="font-size:20pt;"
            class="fa fa-map-marker fa-fw"></i></a>
        <h2 style="min-height:57px;">NECDET ALPATA A.Ş. OTOMOTİV ŞUBESİ</h2>
        <p style="min-height:72px;">Ankara Asfaltı 75.Yıl Mah. &#199;evreyolu Bulvarı No:2 Odunpazarı Eskişehir</p>
        <strong>Tel:</strong> 0 (222) 228 03 30<br />
        <strong>Fax:</strong> 0 (222) 228 03 39<br />
        <strong>Web:</strong> <a href="https://opel.alpata.com/" target="_blank">http://www.alpataotomotiv.com</a><br />
        <strong>Mail: </strong> opelsat@alpata.com
        <br />
        <br />
      </div>
      <div class="col-sm-4 text-center contact-item scrollimation fade-right text-small in" style="font-size:9pt;">
        <a class="icon" href="http://www.alpatasigorta.com/" target="_blank"><i style="font-size:20pt;"
            class="fa fa-map-marker fa-fw"></i></a>
        <h2 style="min-height:57px;">ALPATA SİGORTA ARACILIK HİZMETLERİ LTD. ŞTİ.</h2>
        <p style="min-height:72px;">Ankara Asfaltı 75. Yıl Mah. &#199;evreyolu Bulvarı No:2 Odunpazarı Eskişehir</p>
        <strong>Tel:</strong> 0 (222) 228 03 30<br />
        <strong>Fax:</strong> 0 (222) 228 03 39<br />
        <strong>Web:</strong> <a href="http://www.alpatasigorta.com/"
          target="_blank">http://www.alpatasigorta.com/</a><br />
        <strong>Mail: </strong> sigortainfo@alpata.com
        <br />
        <br />
      </div>
      <div class="col-sm-4 text-center contact-item scrollimation fade-right text-small in" style="font-size:9pt;">
        <a class="icon" href="http://www.alp.com.tr/" target="_blank"><i style="font-size:20pt;"
            class="fa fa-map-marker fa-fw"></i></a>
        <h2 style="min-height:57px;">ALP HAVACILIK SANAYİ VE TİCARET A.Ş.</h2>
        <p style="min-height:72px;">Organize Sanayi B&#246;lgesi 8. Cadde 26110 Eskişehir</p>
        <strong>Tel:</strong> 0 (222) 236 13 00<br />
        <strong>Fax:</strong> 0 (222) 236 12 85<br />
        <strong>Web:</strong> <a href="http://www.alp.com.tr/" target="_blank">http://www.alp.com.tr </a><br />
        <strong>Mail: </strong> alphavacilik@alp.com.tr
        <br />
        <br />
      </div>
      <div class="col-sm-4 text-center contact-item scrollimation fade-right text-small in " style="font-size:9pt;">
        <a class="icon" href="http://www.alpatateknoloji.com/" target="_blank"><i style="font-size:20pt;"
            class="fa fa-map-marker fa-fw"></i></a>
        <h2 style="min-height:57px;">NECDET ALPATA A.Ş. TEKNOLOJİ ŞUBESİ</h2>
        <p style="min-height:72px;">Organize Sanayi B&#246;lgesi Bilim Caddesi Yazılım Kule No:5/401 Odunpazarı
          Eskişehir
        </p>
        <strong>Tel:</strong> 0 (222) 236 23 50<br />
        <strong>Fax:</strong> 0 (222) 236 23 52<br />
        <strong>Web:</strong> <a href="http://www.alpatateknoloji.com/"
          target="_blank">http://www.alpatateknoloji.com</a><br />
        <strong>Mail: </strong> teknoloji@alpata.com
        <br />
        <br />
      </div>
      <div class="col-sm-4 text-center contact-item scrollimation fade-right text-small in " style="font-size:9pt;">
        <a class="icon" href="http://www.alptechnic.com/" target="_blank"><i style="font-size:20pt;"
            class="fa fa-map-marker fa-fw"></i></a>
        <h2 style="min-height:57px;">ALPTEKNİK HAVACILIK SANAYİ VE TİCARET A.Ş.</h2>
        <p style="min-height:72px;">Mustafa Kemal Mahallesi Dumlupınar Bulvarı Tepeprime İş Merkezi No:266 A Blok D:35
          &#199;ankaya Ankara</p>
        <strong>Tel:</strong> 0 (312) 201 87 00<br />
        <strong>Fax:</strong> 0 (312) 201 87 24<br />
        <strong>Web:</strong> <a href="http://www.alptechnic.com/" target="_blank">http://www.alptechnic.com</a><br />
        <strong>Mail: </strong> spares@alp.com.tr
        <br />
        <br />
      </div>
      <div class="col-sm-4 text-center contact-item scrollimation fade-right text-small in " style="font-size:9pt;">
      </div>
      <div class="col-sm-4 text-center contact-item scrollimation fade-right text-small in " style="font-size:9pt;">
        <a class="icon" href="https://alpatahavacilik.com.tr" target="_blank"><i style="font-size:20pt;"
            class="fa fa-map-marker fa-fw"></i></a>
        <h2 style="min-height:57px;">ALPATA HAVACILIK SANAYİ VE TİCARET A.Ş.</h2>
        <p style="min-height:72px;">Organize Sanayi Bölgesi 34. Cadde Numara 15 26110 Odunpazarı/Eskişehir</p>
        <strong>Tel:</strong> 0(222) 236 84 53<br />
        <strong>Web:</strong> <a href="https://alpatahavacilik.com.tr" target="_blank">alpatahavacilik.com.tr</a><br />
        <strong>Mail: </strong> alpatahavacilik@alpata.com
        <br />
        <br />
      </div>

    </div>
    <!--Google Maps Start-->
    <div style="width: 100%;margin-top: 20px; height: 350px;" id="openmap"></div>
    <!--Google Maps End-->

    <div class="row">

      <form class="forms-sample contact-form col-md-6 col-sm-offset-3" (submit)="ekleGuncelle(1)" ngNativeValidate>
        <div class="row">
          <div class="form-group">
            <input type="text" class="form-control" id="Ad" name="Ad" autocomplete="off" placeholder="İsim"
              [(ngModel)]="item.Ad" required="true" />
            <i class="fa fa-user"></i>
          </div>
          <div class="form-group">
            <input type="text" class="form-control" id="Email" name="Email" autocomplete="off" placeholder="E-posta"
              [(ngModel)]="item.Email" required="true" />
            <i class="fa fa-envelope"></i>
          </div>
          <div class="form-group">
            <div class=" controls">
              <select id="contact-company" name="SirketTipi" placeholder="Şirket Seçiniz" required="true"
                [(ngModel)]="item.SirketTipi" class="form-control requiredField label_better">
                <option value="">Şirket Seçiniz</option>
                <option value="0">NECDET ALPATA PAZARLAMA LOJİSTİK VE TURİZM SANAYİ VE TİCARET A.Ş.
                </option>
                <option value="1">NECDET ALPATA A.Ş. OTOMOTİV ŞUBESİ</option>
                <option value="2">ALPATA SİGORTA ARACILIK HİZMETLERİ LTD. ŞTİ.</option>
                <option value="3">ALP HAVACILIK SANAYİ VE TİCARET A.Ş.</option>
                <option value="4">NECDET ALPATA A.Ş. TEKNOLOJİ ŞUBESİ
                </option>
                <option value="5">ALPTEKNİK HAVACILIK SANAYİ VE TİCARET A.Ş.</option>
                <option value="6">ALPATA S.R.L</option>
                <option value="6">ALPATA HAVACILIK SANAYİ VE TİCARET A.Ş.</option>
              </select>
              <i class="fa fa-building-o"></i>
            </div>
          </div>
          <div class="form-group">
            <textarea rows="6" class="form-control" id="Mesaj" name="Mesaj" autocomplete="off" placeholder="Mesaj"
              [(ngModel)]="item.Mesaj" required="true"></textarea>
            <i class="fa fa-comment"></i>
          </div>

          <div #captchaRef2></div>

          <div class="col-md-12">
            <button [disabled]="ekleGuncelleIsLoading" type="submit" class="btn btn-alpata btn-block">
              <span *ngIf="ekleGuncelleIsLoading" role="status" aria-hidden="true"></span>
              <i class="fa fa-location-arrow"></i>Gönder
            </button>
          </div>
        </div>
      </form>

      <!--=== Contact Form ===-->
      <!-- <form id="contact-form" class="col-sm-6 col-sm-offset-3" action="http://alpata.com/tr/Home/Contact" method="get"
        novalidate>

        <div class="form-group">
          <label class="control-label" for="contact-name">İsim</label>
          <div class="controls">
            <input id="contact-name" name="Name" placeholder="İsim" class="form-control requiredField label_better"
              type="text" data-error-empty="Please enter your name">
            <i class="fa fa-user"></i>
          </div>
        </div>

        <div class="form-group">
          <label class="control-label" for="contact-mail">E-posta</label>
          <div class=" controls">
            <input id="contact-mail" name="Email" placeholder="E-posta" class="form-control requiredField label_better"
              type="email" data-error-empty="Please enter your email" data-error-invalid="Invalid email address">
            <i class="fa fa-envelope"></i>
          </div>
        </div>

        <div class="form-group">
          <label class="control-label" for="contact-mail">Şirket</label>
          <div class=" controls">
            <select id="contact-company" name="Company" class="form-control requiredField label_better"
              data-error-empty="Please select a company">
              <option value="">Şirket Se&#231;iniz</option>
              <option value="gidainfo@alpata.com">NECDET ALPATA PAZARLAMA LOJİSTİK VE TURİZM SANAYİ VE TİCARET A.Ş.
              </option>
              <option value="opelsat@alpata.com">NECDET ALPATA A.Ş. OTOMOTİV ŞUBESİ</option>
              <option value="sigortainfo@alpata.com">ALPATA SİGORTA ARACILIK HİZMETLERİ LTD. ŞTİ.</option>
              <option value="alphavacilik@alp.com.tr">ALP HAVACILIK SANAYİ VE TİCARET A.Ş.</option>
              <option value="teknoloji@alpata.com">ALPATA TEKNOLOJİ YAZILIM ve BİLİŞİM HİZMETLERİ SAN. ve TİC. A.Ş
              </option>
              <option value="spares@alp.com.tr">ALPTEKNİK HAVACILIK SANAYİ VE TİCARET A.Ş.</option>
            </select>
            <i class="fa fa-building-o"></i>
          </div>
        </div>

        <div class="form-group">
          <label class="control-label" for="contact-message">Mesaj</label>
          <div class="controls">
            <textarea id="contact-message" name="Content" placeholder="Mesaj"
              class="form-control requiredField label_better" rows="6"
              data-error-empty="Please enter your message"></textarea>
            <i class="fa fa-comment"></i>
          </div>
        </div>
        <div class="col-md-12">
          <div class="col-md-6">
          </div>
          <div class="col-md-6">
            <input class="form-control" id="Captcha_CaptchaChallenge" name="Captcha.CaptchaChallenge"
              placeholder="Güvenlik kodu..." style="max-width: 200px;padding-left:20px;" type="text" value="" />
            <input id="Captcha_CaptchaId" name="Captcha.CaptchaId" type="hidden"
              value="494d64bebb36423fa089837d639657b5" />
          </div>


        </div>

        <p>
          <button name="submit" type="submit" class="btn btn-alpata btn-block" data-error-message="Error!"
            data-sending-message="Gönderiliyor..." data-ok-message="Mesajınız tarafımıza iletildi">
            <i class="fa fa-location-arrow"></i>G&#246;nder
          </button>
        </p>

        <input type="hidden" name="submitted" id="submitted" value="true" />

      </form> -->
      <!-- End contact-form -->
    </div>
  </div>

</section>
